// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9918) return "static/chunks/9918.c223f1ded4b1c20a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"2260":"163cf27b6ecaa990","2621":"a2079d9164482f9d","3879":"897dd0a320b97e7d","4206":"494d8a1edfc967f7","4550":"84d722b5e2f9387e","5217":"e5de8f662849e296","7761":"8a27216f2dd8a2a7","7763":"1b079feabd7fc1f8","7808":"4ba88dec306fff11","9061":"a3a73ec3e4e55d61","9483":"1cc91030e08176c5"}[chunkId] + ".js";
};